import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-olive-900 text-cream py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_trattoria-girasole/artifacts/uud0iqrn_Logo-Il-Girasole-Hallbergmoos-Restaurant.svg" 
              alt="Il Girasole Logo" 
              className="h-16 mb-4"
            />
            <p className="font-body text-cream/80 leading-relaxed">
              Ristorante – Pizzeria<br />
              Authentische italienische Küche am Munich Airport Business Park.
            </p>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="font-heading text-xl text-gold mb-4">Kontakt</h4>
            <div className="space-y-3 font-body text-cream/80">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-terracotta mt-1 flex-shrink-0" />
                <span>
                  Zeppelinstraße 15<br />
                  85399 Hallbergmoos
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-terracotta" />
                <a href="tel:+498119999888" className="hover:text-gold transition-colors">
                  0811 / 99 99 888
                </a>
              </div>
            </div>
          </div>

          {/* Öffnungszeiten */}
          <div>
            <h4 className="font-heading text-xl text-gold mb-4">Öffnungszeiten</h4>
            <div className="space-y-2 font-body text-cream/80">
              <div className="flex items-start gap-3">
                <Clock size={18} className="text-terracotta mt-1" />
                <div>
                  <p className="font-semibold text-cream/90">Mo – Fr</p>
                  <p>11:30 – 14:00 Uhr</p>
                  <p>17:30 – 22:00 Uhr</p>
                  <p className="mt-2 font-semibold text-cream/90">Samstag und Sonntag</p>
                  <p className="text-terracotta">Geschlossen</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-cream/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-cream/60 text-sm font-body">
              © {new Date().getFullYear()} Ristorante Il Girasole. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6">
              <Link
                to="/impressum"
                data-testid="footer-impressum-link"
                className="text-cream/60 hover:text-gold text-sm font-body transition-colors duration-300"
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                data-testid="footer-datenschutz-link"
                className="text-cream/60 hover:text-gold text-sm font-body transition-colors duration-300"
              >
                Datenschutz
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
